if (!customElements.get("upsell-collection-cta")) {
  customElements.define(
    "upsell-collection-cta",
    class extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.a = this.querySelector("a");
        this.a.addEventListener("click", this.onClick.bind(this));
      }

      onClick(event) {
        event.preventDefault();

        const behavior = this.dataset.behavior;
        const cartDrawer = document.querySelector("cart-drawer");

        if (behavior === "open_cart_drawer") {
          cartDrawer.open();
        } else if (behavior === "checkout") {
          cartDrawer.querySelector("#CartDrawer-Checkout").click();
        }
      }
    }
  );
}
